import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="30" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.82 0l1.263 1.469-5.636 6.428L30 7.97l-.004 2.067-26.568-.073 5.661 6.581L7.814 18 0 8.918 7.82 0z" fill="#242424" /></svg>;